const CONSTANTS = process.env.NODE_ENV === 'production' ? {
  API_URL: 'https://api.spamimess.com',
} : {
  API_URL: 'http://localhost:3000',
};

export default CONSTANTS;
